export default __webpack_public_path__ + "static/media/512x512.fdb5b9d4.png";